// src/components/dashboard/table-planner/OverviewPanel.jsx
import React, { useState } from "react";

export default function OverviewPanel({
  tables,
  onRearrangeTables,
  onTableSelect,
}) {
  const [dragOverId, setDragOverId] = useState(null);

  const sortedTables = [...tables].sort(
    (a, b) => a.tableNumber - b.tableNumber
  );

  const handleDragStart = (e, tableId) => {
    e.dataTransfer.setData("type", "table");
    e.dataTransfer.setData("tableId", tableId);
    e.dataTransfer.effectAllowed = "move";
  };

  const handleDrop = (e, targetTableId) => {
    e.preventDefault();
    const draggedTableId = e.dataTransfer.getData("tableId");

    if (draggedTableId && draggedTableId !== targetTableId) {
      onRearrangeTables(draggedTableId, targetTableId);
    }
    setDragOverId(null);
  };

  return (
    <div className=" lg:col-span-1 bg-white/70 p-4 rounded-xl shadow-sm backdrop-blur-sm self-start sticky top-4">
      <h2 className="text-xl font-bold text-[#931b1c] mb-4 border-b pb-2">
        Tables Overview
      </h2>
      <div className="space-y-3 max-h-[calc(100vh-10rem)] overflow-y-auto pr-2">
        {sortedTables.length > 0 ? (
          sortedTables.map((table) => {
            const currentPax = table.guests.reduce((sum, g) => sum + g.pax, 0);
            const fillPercentage =
              table.capacity > 0 ? (currentPax / table.capacity) * 100 : 0;
            const isOverCapacity = currentPax > table.capacity;

            return (
              <div
                key={table.id}
                draggable={true}
                // Add the onClick handler here
                onClick={() => onTableSelect && onTableSelect(table.id)}
                onDragStart={(e) => handleDragStart(e, table.id)}
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragOverId(table.id);
                }}
                onDragLeave={() => setDragOverId(null)}
                onDrop={(e) => handleDrop(e, table.id)}
                // Added cursor-pointer for better UX
                className={`p-3 bg-white rounded-lg cursor-pointer transition-all duration-150 ${
                  dragOverId === table.id ? "ring-2 ring-blue-500" : "shadow-sm"
                }`}
              >
                <div className="flex justify-between items-center mb-1">
                  <p
                    className="font-bold text-gray-800 truncate"
                    title={table.name}
                  >
                    {table.tableNumber}. {table.name}
                  </p>
                  <span
                    className={`font-semibold text-sm ${
                      isOverCapacity ? "text-red-600" : "text-gray-600"
                    }`}
                  >
                    {currentPax} / {table.capacity}
                  </span>
                </div>
                <div className="w-full bg-gray-200 rounded-full h-2.5">
                  <div
                    className={`h-2.5 rounded-full ${
                      isOverCapacity ? "bg-red-500" : "bg-blue-500"
                    }`}
                    style={{ width: `${Math.min(fillPercentage, 100)}%` }}
                  ></div>
                </div>
              </div>
            );
          })
        ) : (
          <p className="text-gray-500 italic">No tables have been created.</p>
        )}
      </div>
    </div>
  );
}
